<div #timelineWrapper id="timelineWrapper">
	<!-- Header  -->
	<svg class="timeline-header" xmlns="http://www.w3.org/2000/svg" [attr.height]="viewboxHeaderHeight" [attr.viewBox]="viewboxHeader" style="overflow:visible">
		<svg y="0" x="0" style="overflow:visible">
            <!-- Years -->
			<ng-container *ngIf="(type == TYPE_TABLE.Monthly || type == TYPE_TABLE.Weekly) && isMainPage">
				<g *ngFor="let year of years; let m = index; trackBy: trackByProperty('year')">
					<rect [attr.height]="BOX_SIZE" [attr.width]="checkBoxWidth(year, 'duration')" [attr.x]="checkBoxStart(year)" [attr.y]="year.positionY" class="box-date" />
					<text class="milestone" fill="rgb(50,50,50)" [attr.y]="year.positionYText" [attr.x]="checkBoxMiddle(year)" text-anchor="middle" dominant-baseline="central">
						{{ year.year | date: 'yyyy' }}
					</text>
				</g>
			</ng-container>
			<!-- Months -->
			<g *ngFor="let month of months; let m = index; trackBy: trackByProperty('month')">
				<rect [attr.height]="BOX_SIZE" [attr.width]="checkBoxWidth(month, 'duration')" [attr.x]="checkBoxStart(month)" [attr.y]="month.positionY" class="box-date" />
				<text class="milestone" fill="rgb(50,50,50)" [attr.y]="month.positionYText" [attr.x]="checkBoxMiddle(month)" text-anchor="middle" dominant-baseline="central">
					{{ month.month | date: 'MMM - yy' }}
				</text>
			</g>
			<!-- Weeks -->
			<ng-container *ngIf="type == TYPE_TABLE.Daily || type == TYPE_TABLE.Weekly">
				<g *ngFor="let week of weeks; let w = index; trackBy: trackByProperty('start_week')">
					<rect [attr.height]="BOX_SIZE" [attr.width]="checkBoxWidth(week)" [attr.x]="checkBoxStart(week)" [attr.y]="week.positionY" class="box-date" />
					<text class="milestone" fill="rgb(50,50,50)" [attr.y]="week.positionYText" [attr.x]="checkBoxMiddle(week)" text-anchor="middle" dominant-baseline="central">
						<tspan *ngIf="isMainPage">{{ week.start_week | date: 'dd' }} - {{week.end_week | date: 'dd' }}</tspan>
						<tspan *ngIf="!isMainPage">{{ week.start_week | date: 'dd' }}</tspan>
					</text>
				</g>
			</ng-container>
			<!-- Days -->
			<ng-container *ngIf="type == TYPE_TABLE.Daily">
                <g *ngFor="let day of days; let d = index; trackBy: trackByProperty('date')">
                    <rect [attr.height]="BOX_SIZE" [attr.width]="BOX_SIZE" class="box-date" [attr.x]="checkBoxStart(day)" [attr.y]="day.positionY"></rect>
					<text class="milestone" fill="rgb(50,50,50)" [attr.y]="day.positionYText" [attr.x]="checkBoxMiddle(day)" text-anchor="middle" dominant-baseline="central">
						<tspan alignment-baseline="text-after-edge">{{ day.date | date: 'dd' }}</tspan>
					</text>
					<text class="milestone" fill="rgb(50,50,50)" [attr.y]="day.positionYText" [attr.x]="checkBoxMiddle(day)" text-anchor="middle" dominant-baseline="central">
						<tspan alignment-baseline="text-before-edge">{{ day.date | date: 'E' |slice:0:1 }}</tspan>
					</text>
					<ng-container *ngIf="day.holliday">
						<text class="milestone text-holiday" fill="rgb(50,50,50)" [attr.y]="day.positionYText + 22" [attr.x]="checkBoxMiddle(day)" text-anchor="middle">
							{{ day.holliday_country_abbr }}
						</text>
					</ng-container>
                </g>
			</ng-container>
        </svg>
    </svg>
	<!-- Timeline table -->
	<div class="wrapper-graphs" [ngClass]="{ 'with-scroll-end': isMainPage }">
		<div class="bar left" [ngStyle]="{'height.px': viewboxTableHeight}" (click)="paginateTable('previous')">
			<span class="material-icons arrow">keyboard_arrow_left</span>
		</div>

		<svg class="timeline-table" xmlns="http://www.w3.org/2000/svg" [attr.height]="viewboxTableHeight" [attr.viewBox]="viewboxTable">
			<!-- Diseño en diagonal -->
			<defs>
				<pattern id="pattern-stripe"
					width="14" height="4"
					patternUnits="userSpaceOnUse"
					patternTransform="rotate(45)">
					<rect width="4" height="4" transform="translate(0,0)" fill="white"></rect>
				</pattern>
				<mask id="mask-stripe">
					<rect x="0" y="0" width="100%" height="100%" fill="url(#pattern-stripe)" />
				</mask>
			</defs>
			<!-- Vertical lines -->
			<ng-container [ngSwitch]="type">
				<svg y="0" x="0" *ngSwitchCase="TYPE_TABLE.Daily">
					<g *ngFor="let day of days; let a = index; let lastDay = last;">
						<line class="vertical-line" [attr.x1]="checkBoxStart(day, 'day')" y1="0" [attr.x2]="checkBoxStart(day, 'day')" [attr.y2]="viewboxTableHeight"
						[ngStyle]="{ 'stroke-width': day.isSunday || day.holliday ? unitSize : 1 }" [ngClass]="{'holiday': day.isSunday || day.holliday}"/>
					</g>
				</svg>
				<svg y="0" x="0" *ngSwitchCase="TYPE_TABLE.Weekly">
					<g *ngFor="let week of weeks; let a = index; let lastWeek = last;">
						<line class="vertical-line" [attr.x1]="checkBoxStart(week)" y1="0" [attr.x2]="checkBoxStart(week)" [attr.y2]="viewboxTableHeight" />
					</g>
				</svg>
				<svg y="0" x="0" *ngSwitchCase="TYPE_TABLE.Monthly">
					<g *ngFor="let month of months; let a = index; let lastMonth = last;">
						<line class="vertical-line" [attr.x1]="checkBoxStart(month)" y1="0" [attr.x2]="checkBoxStart(month)" [attr.y2]="viewboxTableHeight"/>
					</g>
				</svg>

				<!-- Content -->
				<ng-container *ngFor="let project of projects; trackBy: _gS.trackById">
					<svg class="parent_milestones" *ngFor="let phase of project.phases_project; let i = index; let firstPhase = first; trackBy: _gS.trackById" [attr.y]="phase.positionY" [attr.x]="0">
						<!-- Horizontal lines -->
							<!-- Detail phase line -->
								<ng-container *ngIf="project.isOpen">
									<line *ngIf="firstPhase" x1="0" [attr.y1]="0" [attr.x2]="viewboxTableWidth" [attr.y2]="0" style="stroke:rgb(230,230,230);stroke-width:1" />
									<line x1="0" [attr.y1]="BOX_SIZE" [attr.x2]="viewboxTableWidth" [attr.y2]="BOX_SIZE" style="stroke:rgb(230,230,230);stroke-width:1" />
								</ng-container>
		
								<svg y="0" x="0" *ngIf="!phase.isDetail">
									<rect [attr.height]="project.isOpen ? BOX_SIZE : BOX_SIZE / 2" [attr.width]="checkBoxWidth(phase, 'duration')" [attr.x]="checkBoxStart(phase)" y="0" [attr.fill]="phase.color_code" stroke="rgb(230,230,230)" />
								</svg>
								<svg y="0" x="0" *ngIf="phase.isDetail">
									<ng-container *ngFor="let week of phase.weeksDetail; let i = index" >
										<rect [attr.height]="project.isOpen ? BOX_SIZE : BOX_SIZE / 2" [attr.width]="7*unitSize" [attr.x]="checkBoxStart(phase) + (7*unitSize*i)" y="0" [attr.fill]="'rgb(255,255,255)'" stroke-width="4" [attr.stroke]="phase.color_code" />
										<text class="detail" [attr.y]="BOX_SIZE / 2" [attr.x]="checkBoxStart(phase) + (7*unitSize*i) + ((7*unitSize)/2)" text-anchor="middle" dominant-baseline="central">
											W{{ week.week }}
										</text>
									</ng-container>
								</svg>
							<!-- End detail phase line -->

							<!-- Detail task line -->
								<ng-container *ngIf="phase.isOpen && project.isOpen">
									<svg class="child_milestones" *ngFor="let task of phase.tasks; let a = index; trackBy: _gS.trackById" x="0" [attr.y]="task.positionY">
										<line x1="0" [attr.y1]="BOX_SIZE" [attr.x2]="viewboxTableWidth" [attr.y2]="BOX_SIZE" style="stroke:rgb(230,230,230);stroke-width:1" />
										<svg y="0" x="0" *ngIf="task.details.length">
											<ng-container *ngFor="let detail of task.details; trackBy: _gS.trackById" >
												<!-- Box -->
												<g (contextmenu)="onContextChapterTask($event, project, phase, task, detail)">
													<rect 
														*ngIf="detail.breake_duration > 0" 
														[attr.height]="BOX_SIZE" 
														[attr.width]="checkBoxWidth(detail, 'breake_duration')"
														[attr.x]="checkBoxStart(detail)"
														[attr.y]="0" class="hbar" 
														[attr.fill]="task.color_border || phase.color_code"
														[attr.stroke]="task.color_border || phase.color_code"
														stroke-width="2"
													/>
													<rect 
														[attr.height]="BOX_SIZE" 
														[attr.width]="checkBoxRealWidth(detail, 'duration', 'breake_duration')" 
														[attr.x]="checkBoxRealStart(detail, 'real_start', 'breake_duration')" 
														[attr.y]="0"
														[attr.fill]="task.color_code" 
														[attr.stroke]="task.color_border || phase.color_code" 
														stroke-width="2"
													/>
													<text class="detail" [attr.y]="BOX_SIZE / 2" [attr.x]="checkBoxMiddle(detail, 'middle')" text-anchor="middle" dominant-baseline="central">
														{{ detail.text }}{{ task.duration != detail.duration ? '*' : '' }}
													</text>
												</g>
											</ng-container>
										</svg>
									</svg>
								</ng-container>
							<!-- End task line -->

						<!-- End horizontal lines -->
					</svg>
				</ng-container>
				<!-- End Content-->

				<svg y="0" x="0" *ngIf="type == TYPE_TABLE.Daily">
					<ng-container *ngFor="let day of days; let a = index; let lastDay = last;">
						<g *ngIf="day.isSunday || day.holliday">
							<line class="vertical-line opacity" [attr.x1]="checkBoxStart(day, 'day')" y1="0" [attr.x2]="checkBoxStart(day, 'day')" [attr.y2]="viewboxTableHeight"
							[ngStyle]="{'stroke-width': day.isSunday || day.holliday ? unitSize : 1}" [ngClass]="{ 'holiday': day.isSunday || day.holliday, 'day_saturday': day.isSaturday }"/>
						</g>
					</ng-container>
				</svg>
	
				<!-- Mark today -->
				<svg y="0" x="0" *ngIf="todayInfoDay">
					<g>
						<line class="vertical-line today" [attr.x1]="todayStart(todayInfoDay)" y1="0" [attr.x2]="todayStart(todayInfoDay)" [attr.y2]="viewboxTableHeight"/>
					</g>
				</svg>
			</ng-container>
		</svg>

		<div class="bar right" [ngStyle]="{'height.px': viewboxTableHeight}" (click)="paginateTable('next')">
			<span class="material-icons arrow">keyboard_arrow_right</span>
		</div>
	</div>
</div>